// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1731":"d605625a","4134":"42e3ec70","4949":"61485f79","7556":"9ba71c50","9406":"42e3ec70"}[chunkId] + ".chunk.css";
};